import { createFileRoute } from '@tanstack/react-router'
import { Link2Off } from 'lucide-react'

export const Route = createFileRoute('/')({
  component: HomeComponent,
})

function HomeComponent() {
  return (
    <div className="flex min-h-svh items-center justify-center bg-muted/30">
      <div className="text-center max-w-md px-6">
        <div className="space-y-4">
          <div className="flex justify-center">
            <div className="rounded-full bg-muted p-3">
              <Link2Off className="h-6 w-6 text-muted-foreground" />
            </div>
          </div>
          <h1 className="text-xl font-semibold text-foreground">
            Link Required
          </h1>
          <p className="text-muted-foreground text-sm leading-relaxed">
            To view your quotes or invoices, please use the link provided by your vendor.
            If you need a new link, contact them directly.
          </p>
        </div>
      </div>
    </div>
  )
}
